<template>
  <div>
    <h2 class="content-block">Jspdf Practice</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        Put your content here
        <div>
          <button @click="generatePDF">Generate PDF</button>

          <!-- Add the HTML content you want to convert -->
          <div ref="pdfContent">
            <h1>Hello, Landscape F4 PDF!</h1>
            <p>
              This is some <span class="red-text">HTML content</span> with CSS
              styles.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.red-text {
  color: red;
}
</style>

<script>
// import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";

export default {
  methods: {
    // generatePDF() {
    //   // Create a new jsPDF instance with landscape orientation and F4 size
    //   const doc = new jsPDF({
    //     orientation: "landscape",
    //     format: [330, 447], // F4 size in millimeters
    //   });

    //   // Add content to the PDF
    //   doc.text("Hello, Landscape F4 PDF!", 10, 10);

    //   // Save or open the PDF
    //   doc.save("example.pdf");
    // },

    // generatePDF() { error
    //   // Get the HTML element to convert
    //   const pdfContent = this.$refs.pdfContent;

    //   // Configure the PDF options
    //   const pdfOptions = {
    //     margin: 10,
    //     filename: "example.pdf",
    //     image: { type: "jpeg", quality: 0.98 },
    //     html2canvas: { scale: 2 },
    //     jsPDF: { unit: "mm", format: [330, 447], orientation: "landscape" },
    //   };

    //   // Generate the PDF using html2pdf
    //   html2pdf()
    //     .from(pdfContent)
    //     .set(pdfOptions)
    //     .outputPdf()
    //     .then((pdf) => {
    //       // Save or open the PDF
    //       pdf.save();
    //     });
    // },
    generatePDF() {
      const createpdf = this.$refs.pdfContent;
      console.log(createpdf);
      var opt = {
        margin: 10,
        filename: "pdfcreated.pdf",
        html2canvas: {
          scale: 2,
        },
        jsPDF: { unit: "mm", format: [330, 447], orientation: "landscape" },
      };
      html2pdf().set(opt).from(createpdf).save();
    },
  },
};
</script>
